import { Checkbox } from "@mui/material";
import { useState } from "react";
import useColors from "../api/hooks/useColors";
import { operationStatus } from "../components/ActionStatus";

export default function ResponsiveCheckbox({
  defaultValue,
  updateFunction,
  setFetchStatus,
  isPermanentlyDisabled = false,
}) {
  const colors = useColors();
  const [currentValue, setCurrentValue] = useState(defaultValue);
  const [isTempDisabled, setIsTempDisabled] = useState(false);

  const handleChange = (newValue) => {
    setCurrentValue(newValue);
    setIsTempDisabled(true);
    setFetchStatus(operationStatus.LOADING);

    updateFunction(newValue)
      .then(() => {
        setFetchStatus(operationStatus.SUCCESS);
      })
      .catch(() => {
        setFetchStatus(operationStatus.ERROR);
        setCurrentValue(!newValue);
      })
      .finally(() => {
        setIsTempDisabled(false);
      });
  };

  return (
    <Checkbox
      checked={currentValue}
      disableRipple
      disabled={isPermanentlyDisabled || isTempDisabled}
      onChange={() => handleChange(!currentValue)}
      sx={{
        paddingX: 0.3,
        paddingY: 0,
        "& svg": { fontSize: 16 },
        "&.MuiCheckbox-root": {
          color: colors.action_active, // Change the color of the unchecked state
        },
        "&.Mui-checked": {
          color: colors.primary_main, // Change the color when checked
        },
        "&.Mui-disabled": {
          color: colors.primary_16percent, // Change the color when disabled
        },
      }}
    />
  );
}
